import { render, staticRenderFns } from "./solicitedVConcluded.vue?vue&type=template&id=2ebd2352"
import script from "./solicitedVConcluded.vue?vue&type=script&lang=js"
export * from "./solicitedVConcluded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports